import Repository from "../../services/Repository"
import {$appConfig} from "../../../../appConfig";


const reSource =  '/Notifications';


export default {
    get(data ){
        return Repository.get(  `${reSource}/list` + data);
    },
    send(data ){
        return Repository.post(`${reSource}/send` , data);
    },
}
